<div class="row">
  <div class="col-sm-12">
    <div class="form-group">
      <label for="disease" class="label">Tipo de Cuaderno de Campo</label>
      <input type="text" nbInput fullWidth id="disease" readonly="true" name="disease" [(ngModel)]="report.form_name" >
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="form-group">
      <label for="user" class="label">Reportado por</label>
      <input type="text" nbInput fullWidth id="user" readonly="true" name="user" [(ngModel)]="report.reportUser" >
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="form-group">
      <label for="fecha" class="label">Fecha de informe</label>
      <input type="text" nbInput fullWidth id="fecha" readonly="true" name="fecha" [(ngModel)]="report.datetime" >
    </div>
  </div>
</div>
<div class="row" [hidden]="!report.showLocation" >
  <div class="col-sm-12">
    <div class="form-group">
      <label for="fecha" class="label">Localización</label>
      <div class="geometry-container">
        <button  class="geometry-btn" nbButton size="small" status="primary" (click)="editGeometry()"><nb-icon icon="edit-outline"></nb-icon> Editar</button>
        <div  class="panel-body map-container" [attr.id]="config.target" ></div>

      </div>

    </div>
  </div>
</div>

<ngx-customform #customFormInstance [enableEdition]="editionEnabled" [loadCustomform]="customform" [loadReport]="report"></ngx-customform>




